export const namespaced = true;

export const state = {
    types: [],
    elements: [],
    selectedElement: null,
    loadingElements: {},
}

export const mutations = {
    FETCH_TYPES(state, types) {
        const expanded = JSON.parse(localStorage.getItem('expanded_barriers') || '[]');
        for (const key in types) {
            if (Object.hasOwnProperty.call(types, key)) {
                if (state.selectedElement && state.selectedElement.type_id == types[key].type_id) {
                    types[key].showElements = true;
                } else if (expanded.includes(types[key].type_id)) {
                    types[key].showElements = true;
                }
            }
        }
        state.types = types;
    },
    FETCH_ELEMENTS(state, elements) {
        state.elements = elements;
    },
    SELECT_TYPE(state, selectedType) {
        state.selectedType = selectedType;
    },
    SELECT_ELEMENT(state, selectedElement) {
        state.selectedElement = selectedElement;
    },
    SELECT_DOOR_POSITION(state, { item, value }) {
        if (state.selectedElement.doorPosition) {
            state.selectedElement.doorPosition[item] = value;
        }
    },

    SET_TYPE_SHOW_ELEMENTS(state, { typeId, show }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].showElements = show;
            state.types = [...state.types];

            let expanded = JSON.parse(localStorage.getItem('expanded_barriers') || '[]');
            if (show) {
                if (!expanded.includes(typeId)) expanded.push(typeId);
            } else {
                expanded = expanded.filter(id => id !== typeId);
            }
            localStorage.setItem('expanded_barriers', JSON.stringify(expanded));
        }
    },

    SET_TYPE_ELEMENTS(state, { typeId, elements }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            if (state.types[typeIndex].elements.length) {
                elements.forEach(element => {
                    state.types[typeIndex].elements.push(element);
                });
            } else {
                state.types[typeIndex].elements = elements;
            }

            state.types = [...state.types];
        }
    },

    CLEAR_TYPE_ELEMENTS(state, typeId) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].elements = [];
            state.types = [...state.types];
        }
    },

    SET_TYPE_META(state, { typeId, meta }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].meta = meta;
            state.types = [...state.types];
        }
    },

    SET_LOADING_ELEMENTS(state, { typeId, loading }) {
        state.loadingElements[typeId] = loading;
    }
}

export const actions = {

    async fetch({ commit, state, dispatch, rootGetters }) {
        try {
            const res = (await axios.get(`/api/barriers`)).data;
            commit('FETCH_TYPES', res.data.types);
            commit('FETCH_ELEMENTS', res.data.elements);

            const selected = rootGetters["clientOrder/selectedBarriers"];

            if (selected) {
                // dispatch('getElementsByType', selected.type_id);
                dispatch('setTypeShowElements', { typeId: selected.type_id, show: true });
            }
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    selectType({ commit }, selectedType) {
        commit('SELECT_TYPE', selectedType);
    },

    setElement({ commit }, element) {
        commit('SELECT_ELEMENT', element);
    },

    selectElement({ commit, dispatch }, selectedElement) {

        selectedElement = {
            ...selectedElement, doorPosition: {
                side: "c",
                how: "left",
                where: "out",
                wherePlace: "placeRight",
            },
        }

        dispatch('setElement', selectedElement);
        dispatch('clientOrder/addBarrier', selectedElement, { root: true })
    },

    selectDoorPosition({ commit, state, dispatch }, { item, value }) {
        commit('SELECT_DOOR_POSITION', { item, value });
        dispatch('clientOrder/addBarrier', state.selectedElement, { root: true })
    },

    setTypeShowElements({ commit }, { typeId, show }) {
        commit('SET_TYPE_SHOW_ELEMENTS', { typeId, show });
    },

    clearTypeElements({ commit }, typeId) {
        commit('CLEAR_TYPE_ELEMENTS', typeId);
        commit('SET_TYPE_META', { typeId, meta: null });
    },

    async getElementsByType({ commit, dispatch, state, rootState }, typeId) {
        commit('SET_LOADING_ELEMENTS', { typeId, loading: true });
        let page = 1;
        const type = state.types.find(t => t.type_id == typeId);
        if (type && type.meta && type.meta.current_page) {
            page = type.meta.current_page + 1;
        }
        try {
            const res = (await axios.get(`/api/type-barriers/${typeId}`, {
                params: {
                    per_page: parseInt(rootState.settings.settings.count_elements_configurator) || 24,
                    page
                }
            })).data;
            commit('SET_TYPE_ELEMENTS', { typeId, elements: res.data });
            commit('SET_TYPE_META', { typeId, meta: res?.meta });
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        } finally {
            commit('SET_LOADING_ELEMENTS', { typeId, loading: false });
        }
    },



}
